export enum ZipCodeAnalyticsMessages {
  event = 'button click',
  capability = 'guest experience',
  buttonName = 'change zip code',
  modalNameHeader = 'zip code header',
  modalNameBanner = 'zip code banner',
  autoDetectZipCode = 'auto detect zip code',
}
